module.exports = __webpack_public_path__ + "static/p1-8ce6667ef5135d001fc9d8d86af5ab83.jpg";